<template>
  <div class="m-0 dbozone-font bg-virus" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-virus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -virus`">{{ $t('virus.name') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index">
        <div v-if="index===1">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) +  betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) +   betSize[0] + $t('info.to') + betSize[betSize.length-1]  }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="d-flex flex-column nav-virus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -virus`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-virus">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -virus`">{{ $t('main-game.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/wallet_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-balance') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-wallet') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/betamount_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.bet-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet2') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/win_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.win-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-win-amount') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/spin_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.spin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin2') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin3') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/stop_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.stop') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-stop') }}</span>
      </div>
            <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/minus_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.minus') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-minus') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/plus_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.plus') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-plus') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/autospin_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.autospin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/menu_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.menu') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-menu') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/quit_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.quit') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/info_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.pay-info') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-info') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/paytable_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.info-paytable') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-paytable') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/history_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.history') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-history') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/option_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.setting') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-setting') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/virus/close_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{$t('main-game.close') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-close') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-virus',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        'virus.text-rule1',
        'virus.text-rule2',
        '3_5_bonus_20.text-rule3',
        '3_5_bonus_20.text-rule4',
        '3_5_bonus_20.text-rule5',
        '3_5_bonus_20.text-rule6',
        '3_5_bonus_20.text-rule7',
        '3_5_bonus_20.text-rule8',
        '3_5_bonus_20.text-rule9',
        '3_5_bonus_20.text-rule10',
        '3_5_bonus_20.text-rule11',
        '3_5_bonus_20.text-rule12',
        '3_5_base.text-rule16',
        '3_5_base.text-rule17',
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    }
  }
}
</script>

<style>

.bg-virus {
  background:#000088;
}

.nav-virus {
  background: #07BF13;
  border-radius: 10px;
}

.text-title.-virus {
  color: #fff;
}

</style>